(ns frontend.view.settings2.security.mcp-admin.sub
  "Subscriptions for the MCP admin view (tenant admin token management)"
  (:require
   [re-frame.core :as rf]))

(def root-path [::state])

(rf/reg-sub
 ::state
 (fn [db]
   (get-in db root-path)))

(rf/reg-sub
 ::loading?
 :<- [::state]
 (fn [state]
   (:loading? state true)))

(rf/reg-sub
 ::connections
 :<- [::state]
 (fn [state]
   (:connections state [])))

(rf/reg-sub
 ::error
 :<- [::state]
 (fn [state]
   (:error state)))

(rf/reg-sub
 ::revoking-id
 :<- [::state]
 (fn [state]
   (:revoking-id state)))

(rf/reg-sub
 ::revoking-all?
 :<- [::state]
 (fn [state]
   (:revoking-all? state false)))

(rf/reg-sub
 ::revoke-error
 :<- [::state]
 (fn [state]
   (:revoke-error state)))

(rf/reg-sub
 ::sessions-loading?
 :<- [::state]
 (fn [state]
   (:sessions-loading? state false)))

(rf/reg-sub
 ::sessions
 :<- [::state]
 (fn [state]
   (:sessions state [])))

(rf/reg-sub
 ::sessions-error
 :<- [::state]
 (fn [state]
   (:sessions-error state)))

(rf/reg-sub
 ::terminating-session-id
 :<- [::state]
 (fn [state]
   (:terminating-session-id state)))

(rf/reg-sub
 ::undo-tx-id-input
 :<- [::state]
 (fn [state]
   (:undo-tx-id-input state "")))

(rf/reg-sub
 ::undo-preview
 :<- [::state]
 (fn [state]
   (:undo-preview state)))

(rf/reg-sub
 ::undo-loading?
 :<- [::state]
 (fn [state]
   (:undo-loading? state false)))

(rf/reg-sub
 ::undo-error
 :<- [::state]
 (fn [state]
   (:undo-error state)))

(rf/reg-sub
 ::undo-result
 :<- [::state]
 (fn [state]
   (:undo-result state)))

(rf/reg-sub
 ::permissions-loading?
 :<- [::state]
 (fn [state]
   (:permissions-loading? state true)))

(rf/reg-sub
 ::permissions-saving?
 :<- [::state]
 (fn [state]
   (:permissions-saving? state false)))

(rf/reg-sub
 ::permissions-error
 :<- [::state]
 (fn [state]
   (:permissions-error state)))

(rf/reg-sub
 ::permissions-data
 :<- [::state]
 (fn [state]
   (:permissions-data state {:tools []
                             :teams []
                             :users []})))

(rf/reg-sub
 ::permissions-tab
 :<- [::state]
 (fn [state]
   (:permissions-tab state :teams)))

(rf/reg-sub
 ::selected-team-id
 :<- [::state]
 (fn [state]
   (:selected-team-id state)))

(rf/reg-sub
 ::selected-user-id
 :<- [::state]
 (fn [state]
   (:selected-user-id state)))
